var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoreLogo = function SvgCoreLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180.17 208.04"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".coreLogo_svg__cls-2{fill:#e0684b}.coreLogo_svg__cls-3{fill:#bb464b}"))), /*#__PURE__*/React.createElement("g", {
    id: "coreLogo_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coreLogo_svg__Page_Elements",
    "data-name": "Page Elements"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.09 0 0 52v104l90.09 52 90.08-52V52Z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m180.17 52.01-28.2-16.28-27.12 15.66 28.2 16.28zM27.12 67.67l90.09-52.01L90.08 0 0 52.01zM61.89 120.3l28.19 16.28 28.2-16.28-28.2-16.28z",
    className: "coreLogo_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.05 67.67v72.7l-62.97 36.35-62.96-36.35v-72.7L0 52.01v104.02l90.08 52.01 90.09-52.01V52.01z",
    className: "coreLogo_svg__cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.08 71.46 61.89 87.74v32.56l28.19-16.28 28.2 16.28V87.74z",
    className: "coreLogo_svg__cls-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m153.05 67.67-34.77 20.07v32.56l-28.2 16.28v40.14l62.97-36.35z",
    style: {
      fill: "#e0ded8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.12 67.67 34.77 20.07v32.56l28.19 16.28v40.14l-62.96-36.35z",
    style: {
      fill: "#d5d2ca"
    }
  }))));
};
export default SvgCoreLogo;